document.addEventListener("DOMContentLoaded", (event) => { // activate the script after everything has loaded
  // actions
  function toggleDropDown(event) {
    let element = this;
    let accordionBox = document.getElementById("accordionBox-" + element.getAttribute("data-index"));

    if (element.getAttribute("data-toggle") === "false") {
      if (accordionBox && accordionBox.classList.contains("accordionBox-hidden")) {
        accordionBox.classList.remove("accordionBox-hidden");
        accordionBox.classList.add("accordionBox-show");
        element.setAttribute("data-toggle", "true");

        element.classList.remove("is-active");
      }
    }
    else if (element.getAttribute("data-toggle") === "true") {
      if (accordionBox && accordionBox.classList.contains("accordionBox-show")) {
        accordionBox.classList.remove("accordionBox-show");
        accordionBox.classList.add("accordionBox-hidden");
        element.setAttribute("data-toggle", "false");

        element.classList.add("is-active");
      }
    }

    /* if (element.classList.contains('is-active')) {
            element.classList.remove('is-active');
        } else {
            element.classList.add('is-active');
        } */
  }

  // listeners
  try {
    var items = document.getElementsByClassName("accordion-item");
    for (let i = 0; i < items.length; i++) {
      items[i].addEventListener("click", toggleDropDown);
    }
  } catch(err) {
    console.log(err);
  }
});
